<span class="help-tip"><i class="fa fa-question-circle RaboBlue-icon"></i>&nbsp;&nbsp;
    <p>
        <ng-content></ng-content>
    </p>
</span>